// Shared pure-function helpers used by Bond Retrieval / Bond Creation guardian forms.
// Extracted to remove repeated nested-ternary cognitive complexity in the consuming components.

export const getPgEmailRequiredText = (isNewPg, isEsignatures) => {
  if (isNewPg && isEsignatures) {
    return "Email is required for new professional guardians and for e-signature processing of indemnity agreements.";
  }
  if (isNewPg) {
    return "Email is required for new professional guardians to create their account in the system.";
  }
  if (isEsignatures) {
    return "Email is required for e-signature processing of indemnity agreements.";
  }
  return "Email is required.";
};

export const getOccupationQuestionLabel = (employmentStatus) => {
  if (employmentStatus === "Retired") {
    return "What occupation did you retire from?";
  }
  if (employmentStatus === "Employed") {
    return "What is your current occupation?";
  }
  return "Occupation";
};

export const hasPiiAccessForSsn = (role, piiAccess) => {
  if (role === "law_firm_user") return true;
  if (role === "super_user" && piiAccess) return true;
  if (role === "internal_user" && piiAccess) return true;
  return false;
};

export const isHighBondAmount = (bondAmount, threshold = 250000) => {
  return Number(bondAmount || 0) >= threshold;
};
